import { createApp } from 'vue'
import App from './component/app.vue'

createApp(App, {
  inputCompanyEmail: JSON.parse(document.getElementById('app')?.dataset.inputCompanyEmail ?? ''),
  inputCompanyPw: JSON.parse(document.getElementById('app')?.dataset.inputCompanyPw ?? ''),
  actionUrl: JSON.parse(document.getElementById('app')?.dataset.actionUrl ?? ''),
  pwResetUrl: JSON.parse(document.getElementById('app')?.dataset.pwResetUrl ?? ''),
  csrfToken: JSON.parse(document.getElementById('app')?.dataset.csrfToken ?? ''),
  pp: JSON.parse(document.getElementById('app')?.dataset.pp ?? ''),
  mailResult: JSON.parse(document.getElementById('app')?.dataset.mailResult ?? ''),
  resetDone: JSON.parse(document.getElementById('app')?.dataset.resetDone ?? ''),
  settingDone: JSON.parse(document.getElementById('app')?.dataset.settingDone ?? ''),
}).mount('#app')
